import { Container } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

import Data from "../Data/.json";
import { useTranslation } from 'react-i18next';
import Reveal from '../Components/ui/Reveal';
import Waves from '../Components/ui/Waves';

interface Titre {
    titre: string,
    lien?: string,
    image?: any,
    pageDescription: string,
    keyWords: string,
    hiddeTitle?: true,
    eyebrow?: string,
    lead?: string,
    actions?: React.ReactNode
}
function TitrePage(props: Titre) {
    const { t, i18n } = useTranslation();

    return (
        <>
            {/* https://www.ibgalphatech.com/static/media/IBG%20Logo%20without%20background.3bf9cbb04490c8b56cacb2513b95de16.svg */}
            <Helmet>
                <title>{t(props.titre) + " - " + Data.site_name}</title>
                <meta name="description" content={t(props.pageDescription)} />
                <meta name="keywords" content={t(props.keyWords)} />
                <meta name="author" content={Data.site_name} />

                {/* Open Graph */}
                <meta property="og:title" content={t(props.titre) + " - " + Data.site_name} />
                <meta property="og:description" content={t(props.pageDescription)} />
                <meta property="og:image" content={"https://www.ibgalphatech.com/static/media/IBG%20Logo%20without%20background.3bf9cbb04490c8b56cacb2513b95de16.svg"} />
                <meta property="og:url" content={Data.site_link} />
                <meta property="og:type" content="website" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={t(props.titre) + " - " + Data.site_name} />
                <meta name="twitter:description" content={t(props.pageDescription)} />
                <meta name="twitter:image" content={"https://www.ibgalphatech.com/static/media/IBG%20Logo%20without%20background.3bf9cbb04490c8b56cacb2513b95de16.svg"} />
                <meta name="twitter:creator" content={Data.site_name} />

                {/* Open Graph locale (si multilingue) */}
                <meta property="og:locale" content={i18n.language + "_" + (i18n.language === "fr" ? "FR" : "US")} />
                <meta property="og:site_name" content={Data.site_name} />
            </Helmet>
            {!props.hiddeTitle ?
                <section className="ibg-page-hero">
                    <Waves />
                    {props.image && <img className="ibg-hero__media" src={props.image} alt="" />}
                    <div className="ibg-hero__veil" />
                    <Container maxWidth="lg" className="ibg-page-hero__inner">
                        <Reveal>
                            <nav className="ibg-breadcrumb" aria-label="breadcrumb">
                                <Link to="/">{t("Label.Accueil")}</Link>
                                <span>/</span>
                                <span aria-current="page">{t(props.eyebrow ?? props.titre)}</span>
                            </nav>
                        </Reveal>
                        <Reveal delay={0.08}>
                            <h1 className="ibg-page-hero__title">{t(props.titre)}</h1>
                        </Reveal>
                        <Reveal delay={0.16}>
                            <p className="ibg-hero__lead">{t(props.lead ?? props.pageDescription)}</p>
                        </Reveal>
                        {props.actions && <Reveal delay={0.24} className="ibg-actions">{props.actions}</Reveal>}
                    </Container>
                </section>

                :
                <></>
            }
        </>

    )
}

export default TitrePage
